import { Column, Space, Text } from 'farmhub-ui-core';

import { useAppSelector } from 'app';
import { selectAppDevice } from 'slice';
import { DEVICES } from 'utils';

export const emptyImage = {
  ADDRESS:
    'https://public-asset-cdn.ecovation.vn/master/no-data/address_no_data.png',
};

import { Image, CEmpty } from './styles';

export const dataEmpty = {
  DEFAULT: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/account_no_data.png"
    />
  ),
  ACCOUNT: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/account_no_data.png"
    />
  ),
  ADDRESS: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/address_no_data.png"
    />
  ),
  BILL: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/bill_no_data.png"
    />
  ),
  BLOG: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/blog_no_data.png"
    />
  ),
  BLOG_CATEGORY: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/blog_category_no_data.png"
    />
  ),
  VOUCHER: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/voucher_no_data.png"
    />
  ),
  CATEGORY: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/category_no_data.png"
    />
  ),
  DEBT: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/debt_no_data.png"
    />
  ),
  PRODUCT: (
    <Image
      alt="image"
      height="140px"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/category_no_data.png"
      width="140px"
    />
  ),
  OBJECT: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/object_no_data.png"
    />
  ),
  PROCESS: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/process_no_data.png"
    />
  ),
  CERTIFICATION: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/certification_no_data.png"
    />
  ),
  ORDER: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/order_no_data.png"
    />
  ),
  COMMENT: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/comment_no_data.png"
    />
  ),
  IMAGE: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/image_no_data.png"
    />
  ),
  AREA: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/area_no_data.png"
    />
  ),
  SHOP: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/shop_no_data.png"
    />
  ),
  CART: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/shopping_cart_no_data.png"
    />
  ),
  COBUY: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/co_buy_no_data.png"
    />
  ),
  NOTIFICATION: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/notification_no_data.png"
    />
  ),
  BANK_ACCOUNT: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/bank_no_data.png"
    />
  ),
  REVENUE: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/revenue_no_data.png"
    />
  ),
  STAMP: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/stamp_no_data.png"
    />
  ),
  SHOPPING_CART: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/shopping_cart_no_data.png"
    />
  ),
  CAMPAIGN: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/voucher_no_data.png"
    />
  ),
  SEARCH: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/search_no_data.png"
    />
  ),
  SHIPPING: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/shipping_no_data.png"
    />
  ),
  BANNER: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/banner_no_data.png"
    />
  ),
  HISTORY: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/history_no_data.png"
    />
  ),
  MISSION: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/task_no_data.png"
    />
  ),
  PRODUCTION_PLAN: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/production_plan_no_data.png"
    />
  ),
  MATERIAL: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/material_no_data.png"
    />
  ),
  MATERIAL_CATEGORY: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/material_category_no_data.png"
    />
  ),
  MATERIAL_SUB_CATEGORY: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/material_sub_category_no_data.png"
    />
  ),
  SECTION: (
    <Image
      alt="image"
      loading="lazy"
      src="https://public-asset-cdn.ecovation.vn/master/no-data/section_no_data.png"
    />
  ),
};

export interface EmptyProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  img?: React.ReactNode;
  minHeight?: number | string;
  children?: React.ReactNode;
  paddingTop?: number;
  imgSize?: string;
}

const Empty = ({
  title,
  description = 'Không tìm thấy dữ liệu',
  img = dataEmpty.DEFAULT,
  minHeight,
  children,
  paddingTop = 100,
  imgSize,
}: EmptyProps): JSX.Element => {
  const appDevice = useAppSelector(selectAppDevice);

  const renderElements = {
    [DEVICES.DESKTOP]: (
      <>
        {title ? (
          <Column
            alignItems="center"
            className="empty-data"
            justifyContent="center"
            styles={{ minHeight: minHeight || 280 }}
          >
            <Space height={paddingTop} />
            <CEmpty
              description={
                <Column alignItems="center" styles={{ gap: 4 }}>
                  <Text weight="medium">{title}</Text>
                  {description ? (
                    <Text size="xxs" weight="normal">
                      {description}
                    </Text>
                  ) : null}
                </Column>
              }
              height={imgSize || '90px'}
              image={img}
              padding="10px"
              width={imgSize || '90px'}
            >
              {children}
            </CEmpty>
          </Column>
        ) : (
          <Column
            alignItems="center"
            className="empty-data"
            justifyContent="center"
            styles={{ minHeight: minHeight || 280 }}
          >
            {/* <Space height={100} /> */}
            <CEmpty
              description={description}
              fontSize="13px"
              height="90px"
              image={img}
              padding="10px"
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
              width="90px"
            >
              {children}
            </CEmpty>
          </Column>
        )}
      </>
    ),
    [DEVICES.MOBILE]: (
      <>
        {title ? (
          <Column
            alignItems="center"
            justifyContent="center"
            styles={{ minHeight: minHeight || 280 }}
          >
            <Space height={100} />
            <CEmpty
              description={
                <Column alignItems="center">
                  <Text weight="bold">{title}</Text>
                  <Text size="xxs" weight="normal">
                    {description}
                  </Text>
                </Column>
              }
              height="100px"
              image={img}
              padding="10px"
              width="100px"
            >
              {children}
            </CEmpty>
          </Column>
        ) : (
          <Column
            alignItems="center"
            justifyContent="center"
            styles={{ minHeight: minHeight || 280 }}
          >
            <Space height={100} />
            <CEmpty
              description={description}
              fontSize="13px"
              height="70px"
              image={img}
              padding="10px"
              width="70px"
            >
              {children}
            </CEmpty>
          </Column>
        )}
      </>
    ),
    [DEVICES.TABLET]: (
      <>
        {title ? (
          <Column
            alignItems="center"
            justifyContent="center"
            styles={{ minHeight: minHeight || 280 }}
          >
            <Space height={100} />
            <CEmpty
              description={
                <Column alignItems="center">
                  <Text weight="bold">{title}</Text>
                  <Text size="xxs" weight="normal">
                    {description}
                  </Text>
                </Column>
              }
              height="100px"
              image={img}
              padding="10px"
              width="100px"
            >
              {children}
            </CEmpty>
          </Column>
        ) : (
          <Column
            alignItems="center"
            justifyContent="center"
            styles={{ minHeight: minHeight || 280 }}
          >
            <Space height={100} />
            <CEmpty
              description={description}
              fontSize="12px"
              height="70px"
              image={img}
              padding="10px"
              width="70px"
            >
              {children}
            </CEmpty>
          </Column>
        )}
      </>
    ),
  };

  return renderElements[appDevice.device];
};

export default Empty;
